<template>
  <div class="login-page page-padding-top">
    <div class="title">{{ $t('huan-ying-deng-lu-fmall-ex', { appName: $store.state.appName }) }}</div>

    <div class="tabs flex-center" v-show="step == 1">
      <div class="tab flex-center" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{ $t('shou-ji-deng-lu') }}</div>
      <div class="tab flex-center" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{ $t('you-xiang-deng-lu') }}</div>
    </div>


    <div class="login-form">
      <div class="form-label" v-if="tabIndex == 2 && step == 1">{{ $t('you-xiang-hao-ma') }}</div>
      <div class="form-item  flex-center" v-if="tabIndex == 2 && step == 1">
        <div class="input">
          <input type="text" v-model="form.username" :placeholder="$t('qing-shu-ru-you-xiang-hao-ma')">
        </div>
      </div>

      <div class="form-label" v-if="tabIndex == 1 && step == 1">{{ $t('shou-ji-hao-ma') }}</div>
      <div class="form-item  flex-center " :class="inputActive ? 'active' : ''" v-if="tabIndex == 1 && step == 1">
        <a-select v-model="phonePre" option-label-prop="label" dropdownClassName="country-select" class="hide-border">
          <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
          <a-select-opt-group  v-for="(item, i) in countryList" :key="i">
            <span slot="label">{{item.title}}</span>
            <a-select-option v-for="(child, index) in item.children" :key="index" :value="child.key" :label="child.key">
              {{child.title}}
            </a-select-option>
          </a-select-opt-group>
        </a-select>
        <div class="flex-1">
          <div class="input clear">
            <input type="tel" v-model="form.phone" @focus="inputActive = true" @blur="inputActive = false" :placeholder="$t('qing-shu-ru-shou-ji-hao-ma')">
          </div>
        </div>
      </div>

      <div class="form-label" v-show="step == 1">{{ $t('register.label7') }}</div>
      <div class="form-item flex-center" v-show="step == 1">
        <div class="input">
          <input :type="showPassword ? 'text' : 'password'" v-model="form.password" :placeholder="$t('qing-shu-ru-deng-lu-mi-ma')">
        </div>
        <div class="adot" @click="changePassword">
          <img :src="eyeUrl" alt="" v-show="!showPassword">
          <img :src="eyeUrl2" alt="" v-show="showPassword">
        </div>
      </div>

      <div class="form-label" v-show="step == 2 ">
        {{$t(`register.label6_${tabIndex}`)}}
      </div>

      <div class="form-item clear flex-center" v-show="step == 2" >
        <div class="input ">
          <input type="tel"  v-model="form.code"  :placeholder="i18n.t('register.labelPlaceholder2')">
        </div>
        <div class="adot long">
          <span class="gray" v-if="isDisabled">{{$t('register.send')}}({{timeCount}})</span>
          <span v-else @click="resend">{{$t('register.btn1')}}</span>
        </div>
      </div>
    </div>


    <Button class="login-btn" :class="btnShow ? '' : 'disabled'" @click="submit">{{ $t('resetPassword.login') }}</Button>

    <div class="flex-center-between bottom-line" v-show="step == 1">
      <div class="text" @click="toRegister">{{ $t('login.register') }}</div>
      <div class="forget " @click="toReset">{{ $t('resetPassword.title1') }}</div>
    </div>
  </div>
</template>
<script>
  import { Button, Popup, Icon } from 'vant'
  import { login, phoneLogin, sendCode, checkEmailCode, sendSms, checkPhoneCode } from '@/api/login'
  import { setToken, setUser, setUserEmail, setUserId } from '@/utils/auth'
  export default {
    components: {
      Button,
      Popup,
      Icon
    },
    data() {
      return {
        step: 1,
        form: {
          username: '',
          phone: '',
          password: ''
        },
        eyeUrl: require('../../assets/imgs/icon-eye.png'),
        eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
        downUrl: require('../../assets/imgs/icon-arrow-down2.png'),
        keyword: '',
        phonePre: '+1',
        showPassword: false,
        inputActive: false,
        tabIndex: 1,
        showPopup: false,
        countryList: [],
        linkList: [],
        isDisabled: false,
        sendTime: '',
      }
    },
    computed: {
      countryListBak() {
        return this.$store.state.countryList
      },
      btnShow() {
        if (this.step == 1) {
          if (this.tabIndex == 2) {
            return this.form.username && this.form.password
          } else {
            return this.form.phone && this.form.password
          }
        } else {
          return this.form.code
        }
      },
      timeCount() {
        return this.sendTime + 's'
      },
    },
    mounted() {
      this.countryList = [].concat(this.countryListBak)
      this.linkList = this.countryList.filter(v => {
        return v.id != 'common'
      })
    },
    methods: {
      changeTab(index) {
        this.tabIndex = index
      },
      back() {
        this.$router.push({
            name: 'index'
        })
      },
      toPath(path) {
        if (path) {
          this.$router.push({
            name: path
          })
        }
      },
      toRegister() {
        this.$router.push({ name: 'register', query: this.$route.query })
      },
      toReset() {
        this.$router.push({ name: 'resetPassword', query: this.$route.query })
      },
      changePassword() {
        this.showPassword = !this.showPassword
      },
      submit() {
        if (!this.btnShow) {
          return
        }
        if (this.step == 1) {
          this.doLogin()
        } else {
          this.doLogin(true)
        }
      },
      doLogin(isLast) {
        if (this.tabIndex == 2) {
          let param = {
            Email: this.form.username,
              Password: this.form.password,
          }
          if (isLast) {
            param.Code = this.form.code
          }
          login(param).then(res => {
            if (res.code == 0) {
              this.$toast.success(this.$t('login.success'))
              setToken(res.data.token)
              setUser(this.form.username)
              setUserEmail(this.form.username)
              setUserId(res.data.id)
              this.$store.state.isLogin = true
              const redirect = this.$route.query.redirect
              this.$router.replace(redirect || { name: 'index' })
            } else if (res.code == 1) {
              this.sendEmail()
            } else {
                this.$toast.fail(res.msg)
            }
          })
        } else {
          let param = {
            Phone: this.phonePre + this.form.phone,
            Password: this.form.password,
          }
          if (isLast) {
            param.Code = this.form.code
          }
          phoneLogin(param).then(res => {
            if (res.code == 0) {
              this.$toast.success(this.i18n.t('login.success'))
              setToken(res.data.token)
              setUser(this.phonePre + this.form.phone)
              setUserEmail('')
              setUserId(res.data.id)
              this.$store.state.isLogin = true
              const redirect = this.$route.query.redirect
              this.$router.replace(redirect || { name: 'index' })
            } else if (res.code == 1) {
              this.sendPhoneSms()
            }  else {
              this.$toast.fail(res.msg)
            }
          })
        }
      },
      cancel() {
        this.showPopup = false
      },
      changePre() {
        this.showPopup = true
      },
      chooseCountry(data) {
        this.phonePre = data.key
        this.showPopup = false
      },
      getCountryName(name) {
        if (!name) {
          return ''
        }
        let newName = ''
        newName = name.substring(0, name.indexOf('(') - 1)
        return newName
      },
      searchCountry() {
        if (this.keyword) {
          this.countryList = this.countryListBak.map(v => {
            let children = v.children.filter(val => {
              return val.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1 && v.id != 'common'
            })
            if (children.length > 0) {
              return {
                children: children
              }
            } else {
              return {
                children: []
              }
            }
          })
        } else {
          this.countryList = [].concat(this.countryListBak)
        }
      },
      toFastPage(key) {
        let dom = document.getElementById(key.id)
        let parentDom = document.querySelector('.country-list')
        if (dom && parentDom) {
          let domTop = dom.offsetTop
          parentDom.scrollTo({
            top: domTop - 124
          })
        }
      },
      resend() {
        if (this.isDisabled) {
          return
        } else {
          this.sendEmail()
        }
      },
      countDown(time) {
        if (time > 0) {
          this.isDisabled = true
          time -= 1
          this.sendTime = time
          setTimeout(() => {
            this.countDown(time)
          }, 1000)
        } else {
          this.sendTime = ''
          this.isDisabled = false
        }
      },
      sendPhoneSms(){
        if (!this.form.phone) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder8'))
          return
        }
        let form = new FormData()
        form.append('Phone', this.phonePre + this.form.phone)
        form.append('Type', 5)
        sendSms(form).then(res => {
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendEmail() {
        if (!this.form.username) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder1'))
          return
        }
        let form = new FormData()
        form.append('Email', this.form.username)
        form.append('Type', 5)
        sendCode(form).then(res => {
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      toSet() {
        if (!this.form.code ) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder2'))
          return
        }
        let form = new FormData()
        form.append('Code', this.form.code)
        form.append('Type', 5)
        if (this.tabIndex == 2) {
          form.append('Email', this.form.username)
          checkEmailCode(form).then(res => {
            if (res.code == 0) {
              this.doLogin()
            } else {
              this.$toast.fail(res.msg)
            }
          })
        } else {
          form.append('Phone', this.phonePre + this.form.phone)
          checkPhoneCode(form).then(res => {
            if (res.code == 0) {
              this.doLogin()
            } else {
              this.$toast.fail(res.msg)
            }
          })
        }
      }
    }
  }
</script>
